export const eventTypes = {
  REVIEW_QUEUE_OFF: 'Review Queue Off',
  REVIEW_QUEUE_ON: 'Review Queue On',
  REVIEW_ACCEPTED: 'Review Accepted',
};
